// extracted by mini-css-extract-plugin
module.exports = {"root":"sugary-beverage-disposal-page_root__T9kie"};